import { observer } from "mobx-react-lite";
import * as React from "react";
import { CvpButton } from "../../generic-components/buttons/CvpButton";
import { useLocStore } from "../../localization";
import { LocContext } from "../../localization/LocContext";
import { useStorageBackedState } from "../../utils/useStorageBackedState";

export interface AdminProps {
  showVpnTools: boolean;
  setShowVpnTools: (showVpnTools: boolean) => void;
}
export const AdminContext = React.createContext<AdminProps>(null);

export const AdminProvider = ({ children }: { children: React.ReactNode }) => {
  const [showVpnTools, setShowVpnTools] = useStorageBackedState<boolean>(
    "showVpnTools",
    false
  );

  const value = { showVpnTools, setShowVpnTools };

  return (
    <AdminContext.Provider value={value}>{children}</AdminContext.Provider>
  );
};

export function useShowVpnTools() {
  return React.useContext(AdminContext).showVpnTools && !!window.isLocalIp;
}

export interface VpnToolsToggleButtonProps {
  onDeactivate?: () => void;
}
export const VpnToolsToggleButton = observer(
  (props: VpnToolsToggleButtonProps) => {
    const { onDeactivate } = props;
    const L = useLocStore(LocContext.PROFILE);
    const showVpnTools = useShowVpnTools();
    const adminContext = React.useContext(AdminContext);

    return (
      <CvpButton
        className="vpn-item vpn-only"
        iconPos="left"
        icon={showVpnTools ? "pi pi-fw pi-check-circle" : "pi pi-fw pi-circle"}
        label={L.id("eecdfc53291b").loc("Vis VPN verktøy")}
        onClick={(evt) => {
          const newValue = !showVpnTools;

          adminContext.setShowVpnTools(newValue);
          if (!newValue && onDeactivate) {
            onDeactivate();
          }
        }}
        outlined
      />
    );
  }
);
